export default __webpack_public_path__ + "static/media/11.9a6223a2.jpg";